"use client";

/**
 * Le chrome du site, et l'unique endroit qui decide de ne pas le poser.
 *
 * ⛔⛔ POURQUOI CE COMPOSANT EXISTE. La page de certification se monte HORS du
 * chrome. Ce n'est pas une preference de composition, c'est une contrainte de
 * positionnement : le kit certificat pose six couches en `position: fixed`
 * (grain plein ecran, cachet, reglette du sommaire, boutons flottants, jauge de
 * lecture, evitement clavier), dont quatre passent au-dessus d'un en-tete en
 * z-40. Mesure du kit, 2026-09-08 : la reglette et le retour en haut se
 * dessinaient par-dessus le pied de page, et la jauge mesurait la progression
 * d'un document valant en-tete + certificat + pied, donc n'atteignait jamais sa
 * fin sur le certificat.
 *
 * ⭐ La page porte deja son propre `<main id="contenu">` et sa propre sortie,
 * « Revenir au site ». La navigation de l'en-tete y serait un doublon, et
 * imbriquer deux `<main>` est invalide.
 *
 * ⚠️ POURQUOI PAS LE GROUPE DE ROUTES PRESCRIT PAR LE KIT. Le kit prescrit de
 * descendre le chrome dans `app/(site)/layout.tsx`. Ici cela imposerait de
 * deplacer `(global)` et de reecrire 558 imports `@/(global)/...` sur un site
 * client en production. Header, Footer, WhatsAppCTA et MobileActionBar sont
 * deja des composants client qui lisent `usePathname` : un seul point de
 * decision donne le meme resultat, sans toucher a l'arborescence des routes.
 *
 * ⛔ Un seul endroit decide. Ne pas dupliquer ce test dans les composants :
 * c'est exactement ainsi qu'un des quatre finit par etre oublie.
 */

import { usePathname } from "next/navigation";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppCTA } from "@/components/Whatsapp";
import { MobileActionBar } from "@/components/layout/MobileActionBar";

/** La seule route du site qui se monte sans chrome. */
export const ROUTE_SANS_CHROME = "/certification";

const sansChrome = (pathname: string | null) =>
  (pathname ?? "") === ROUTE_SANS_CHROME;

/** En-tete, contenu, pied. Sur la certification : le contenu seul. */
export function ChromeSite({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  if (sansChrome(pathname)) return <>{children}</>;
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}

/** Les deux appels flottants, eux aussi en position fixe. */
export function WidgetsFlottants() {
  const pathname = usePathname();
  if (sansChrome(pathname)) return null;
  return (
    <>
      <WhatsAppCTA />
      <MobileActionBar />
    </>
  );
}
